import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21072236"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "table table-tenant table-hover" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ID", -1))
const _hoisted_5 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_6 = { colspan: "12" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = ["onClick"]

import { ref, onMounted } from "vue";
import PaymentService from "../services/PaymentService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import CryptoTransaction from "../components/crypto/CryptoTransaction.vue";
import {
  CryptoStatusTypeOptions,
  CryptoStatusTypes,
} from "@/core/types/crypto/CryptoStatus";
import notification from "@/core/plugins/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentCryptoIndex',
  setup(__props) {

const isLoading = ref(false);
const isSubmitting = ref(false);
const cryptoTransactionRef = ref<any>(null);
const accountSelected = ref(0);
const data = ref(<any>[]);

const criteria = ref<any>({
  page: 1,
  size: 30,
  showInactive: false,
  category: "PaymentCrypto",
  // for PaymentCrypto view we always send category PaymentCrypto and no status filter
  status: null,
});

const updateStatus = async (item: any) => {
  isSubmitting.value = true;
  try {
    await PaymentService.updateCryptoWalletStatus(item.id, item.status);
    notification.success();
  } catch (error) {
    console.log(error);
    notification.danger();
  }
  isSubmitting.value = false;
};

const fecthData = async () => {
  isLoading.value = true;
  try {
    // always request PaymentCrypto and do not filter by status
    criteria.value.category = "PaymentCrypto";
    criteria.value.status = null;
    const res = await PaymentService.queryCryptoWallets(criteria.value);
    const items = Array.isArray(res) ? res : res.data ?? [];
    data.value = items;
    console.log("PaymentCryptoIndex - fetched items:", items);
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const showAddCryptoModal = () => {
  /* not used in this view */
};

const view = (item: any) => {
  cryptoTransactionRef.value.show(item);
};

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};

const getStatusLabel = (value: number) => {
  // CryptoStatusTypeOptions is expected to be a ref with { value, label } items
  const option = (CryptoStatusTypeOptions as any).value?.find(
    (option: any) => option.value === value
  );
  return option ? option.label : "";
};

function getStatusTag(status: any) {
  switch (status) {
    case CryptoStatusTypes.Idle:
      return "success";
    case CryptoStatusTypes.InUse:
      return "warning";
    case CryptoStatusTypes.Inactive:
      return "danger";
    default:
      return "primary";
  }
}

onMounted(() => {
  fecthData();
});

return (_ctx: any,_cache: any) => {
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.onOff")), 1),
              _hoisted_4,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.type")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.walletAddress")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.balance")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_6, [
                    _createVNode(ScaleLoader, { color: '#ffc730' })
                  ])
                ])
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
              'row-inactive': item.status === _unref(CryptoStatusTypes).Inactive,
            }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, [
                        (item.status != _unref(CryptoStatusTypes).InUse)
                          ? (_openBlock(), _createBlock(_component_el_switch, {
                              key: 0,
                              modelValue: item.status,
                              "onUpdate:modelValue": ($event: any) => ((item.status) = $event),
                              size: "large",
                              style: {"--el-switch-on-color":"#13ce66","--el-switch-off-color":"#ff4949"},
                              "inline-prompt": "",
                              "active-value": _unref(CryptoStatusTypes).Idle,
                              "inactive-value": _unref(CryptoStatusTypes).Inactive,
                              "active-text": "ON",
                              "inactive-text": "OFF",
                              onChange: ($event: any) => (updateStatus(item)),
                              loading: isSubmitting.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "active-value", "inactive-value", "onChange", "loading"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, _toDisplayString(item.type), 1),
                      _createElementVNode("td", null, _toDisplayString(item.address), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_tag, {
                          size: "large",
                          type: getStatusTag(item.status)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getStatusLabel(item.status)), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.balance ?? item.balanceInCents ?? "-"), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn,
                          type: "GMToneLiner"
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (view(item)),
                          plain: "",
                          disabled: isSubmitting.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.view")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ])
                    ], 10, _hoisted_9))
                  }), 128))
                ]))
        ])
      ])
    ]),
    _createVNode(CryptoTransaction, {
      ref_key: "cryptoTransactionRef",
      ref: cryptoTransactionRef
    }, null, 512)
  ], 64))
}
}

})